// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import productSelectorReducer, {
    ProductSelectorActions,
} from "@store/Extensions/Store/Components/ProductSelector/ProductSelectorReducer";
import getExtensionPropsFromCombinedReducer from "@toolkit/Framework/Common/Utilities/redux/getExtensionPropsFromCombinedReducer";
import { combineReducers } from "redux";

const componentsReducer = combineReducers({
    ...getExtensionPropsFromCombinedReducer(reducers.components),
    productSelector: productSelectorReducer,
});

export type ComponentsActions = ProductSelectorActions;

export default componentsReducer;
